import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const generateXlsx = (data, productDetailHeaderData, header, title) => {
  const ws = XLSX.utils.aoa_to_sheet([]);

  const keys = Object.keys(productDetailHeaderData);
  XLSX.utils.sheet_add_aoa(ws, [keys], { origin: "A1" });

  const values = Object.values(productDetailHeaderData);
  XLSX.utils.sheet_add_aoa(ws, [values], { origin: "A2" });

  // Add a blank row
  XLSX.utils.sheet_add_aoa(ws, [[]], { origin: "A3" });

  XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A4" });

  XLSX.utils.sheet_add_json(ws, data, { origin: "A5", skipHeader: true });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "data");

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true,
  });
  const finalData = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });
  saveAs(finalData, title + ".xlsx");
};

export default generateXlsx;
